import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

const navItems = [
  { to: '/admin', end: true, label: 'Dashboard' },
  { to: '/admin/categories', label: 'Kategoriler' },
  { to: '/admin/products/davetiyeler', label: 'Davetiye Ürünleri' },
  { to: '/admin/products/sekerlik', label: 'Şekerlik Ürünleri' },
  { to: '/admin/digital-invitations', label: 'Dijital Davetiyeler' },
  { to: '/admin/settings', label: 'Site Ayarları' },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-sidebar__brand">
          <h1>Admin Panel</h1>
          <p>Eskişehir Davetiye</p>
        </div>

        <nav className="admin-nav" aria-label="Admin menü">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar__footer">
          <a href="/" target="_blank" rel="noreferrer">
            Siteyi görüntüle ↗
          </a>
          {user?.username && (
            <p style={{ margin: '0 0 0.75rem', fontSize: '0.75rem', color: 'rgba(255,255,255,0.45)' }}>
              {user.username}
            </p>
          )}
          <button type="button" className="admin-sidebar__logout" onClick={handleLogout}>
            Çıkış yap
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <Outlet />
      </div>
    </div>
  );
}
